import { isUndefined } from 'lodash';
import { useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from 'components/Typography';
import { LearningPathCtx, withLearningPathContext } from 'domains/learning-path/context';
import { LearningPathStepID } from 'domains/learning-path/steps';
import { AnswerAndContinueContent } from './AnswerAndContinue';
import { TrueOrFalseContent } from './TrueOrFalse';

const KnowledgeCheckContent: React.FC = () => {
  const {
    learningPath: {
      knowledgeCheckSection: {
        fields: { questions },
      },
    },
    onComplete,
  } = useContext(LearningPathCtx);

  const { t } = useTranslation();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);
  const [currentAnswer, setCurrentAnswer] = useState<boolean | undefined>();

  const currentQuestion = useMemo(() => questions[currentQuestionIndex], [currentQuestionIndex, questions]);

  const handleAnswer = (answer: boolean) => {
    setCurrentAnswer(answer);
  };

  const handleNextQuestion = () => {
    if (currentQuestionIndex + 1 === questions.length) {
      onComplete();
    } else {
      setCurrentQuestionIndex(current => current + 1);
      setCurrentAnswer(undefined);
    }
  };

  return (
    <>
      <Heading level="h3" useDefaultMargins>
        {t('learningPath.knowledgeCheck.letsReview')}
      </Heading>

      <div className="flex flex-col items-center justify-center w-full min-h-[480px] bg-white rounded-lg py-80 px-40 sm-d:p-32 gap-40 sm-d:gap-32">
        {currentQuestion && isUndefined(currentAnswer) && (
          <TrueOrFalseContent question={currentQuestion.fields.question} onAnswer={handleAnswer} />
        )}

        {currentQuestion && !isUndefined(currentAnswer) && (
          <AnswerAndContinueContent
            answerLong={currentQuestion.fields.answerLong}
            answer={currentQuestion.fields.correctAnswer}
            onContinue={handleNextQuestion}
          />
        )}
      </div>
    </>
  );
};

export default withLearningPathContext(KnowledgeCheckContent, LearningPathStepID.knowledgeCheck);
